import type { ClosingPackagePhase, ClosingPackageWorkflowState } from '../types';

/**
 * Workflow / phase labels for Closing Package UI (FE-002+).
 * Phase labels reuse existing utils/closingPackageUi meta where possible.
 * WorkflowState is the authoritative display state per Design Freeze.
 */

export const CLOSING_PACKAGE_WORKFLOW_STATE_META: Record<
  ClosingPackageWorkflowState,
  { label: string; color: string }
> = {
  NOT_AVAILABLE: { label: 'Недоступен', color: 'default' },
  DRAFT: { label: 'Черновик состава', color: 'orange' },
  FORMED: { label: 'Комплект сформирован', color: 'blue' },
  SCAN_REVIEW_REQUIRED: { label: 'Требуется отправка сканов', color: 'gold' },
  SCANS_SENT_TO_CLIENT: { label: 'Сканы отправлены клиенту', color: 'processing' },
  WAITING_CLIENT_APPROVAL: { label: 'Ожидание согласования клиента', color: 'processing' },
  REVISION_REQUIRED: { label: 'Требуется доработка', color: 'error' },
  CLIENT_APPROVED: { label: 'Согласовано клиентом', color: 'success' },
  ORIGINALS_PREPARATION: { label: 'Подготовка оригиналов', color: 'cyan' },
  ORIGINALS_SENT: { label: 'Оригиналы отправлены', color: 'blue' },
  CLIENT_RECEIVED: { label: 'Оригиналы получены клиентом', color: 'green' },
  COMPLETED: { label: 'Завершён', color: 'green' },
  CANCELLED: { label: 'Отменён', color: 'default' },
};

/** Legacy phase labels — keep for read-only ClosingPackageBlock until FE-002. */
export const CLOSING_PACKAGE_PHASE_LABELS: Record<ClosingPackagePhase, string> = {
  NOT_AVAILABLE: 'Недоступен',
  COLLECTING: 'Формирование комплекта',
  READY_TO_SEND: 'Комплект готов к отправке',
  DISPATCHED: 'Отправлен клиенту на согласование',
  RECEIVED_BY_CLIENT: 'Получен клиентом',
};

export function closingPackageWorkflowStateMeta(state: ClosingPackageWorkflowState | null | undefined) {
  if (!state) {
    return CLOSING_PACKAGE_WORKFLOW_STATE_META.NOT_AVAILABLE;
  }
  return CLOSING_PACKAGE_WORKFLOW_STATE_META[state] ?? CLOSING_PACKAGE_WORKFLOW_STATE_META.NOT_AVAILABLE;
}
